module.exports = __webpack_public_path__ + "img/watchlist-success.b0ae5dd1.svg";